import styled from '@emotion/styled';

import { connectLocation } from './location/LocationConnectors';
import wrappedInReduxProvider from './wrappedInReduxProvider';
import withDefaultPrevented from '../withDefaultPrevented';

const ChangeLocationButton = styled.a`
  -webkit-appearance: none;
  align-items: center;
  border: 0;
  text-decoration: underline;
  cursor: pointer;
  display: inline-flex;
  font-size: 15px;
  font-weight: 500;
  margin-left: 4px;

  svg {
    margin-right: 5px;
  }
`;

// openLocationModal provided by the connectLocation HOC
const LocationModalOpener = ({
  className = 'oc-icon',
  dataTM = '',
  dataTrack = '',
  dataTrackModalName = '',
  openLocationModal,
  ariaLabel = '',
  text = 'Change',
  showIcon = true,
}) => (
  <ChangeLocationButton
    tabIndex={0}
    className={className}
    aria-label={ariaLabel}
    data-tm={dataTM}
    data-track={dataTrack}
    data-track-modal-name={dataTrackModalName}
    href="#"
    onClick={withDefaultPrevented(openLocationModal)}
    onKeyPress={e => {
      if (e.key === 'Enter' || e.key === 'Space') {
        withDefaultPrevented(openLocationModal);
      }
    }}
  >
    {showIcon && <i className="icon location" aria-hidden="true" />}
    {text}
  </ChangeLocationButton>
);

// We wrap LocationModalOpener in the connectLocation HOC
// to get access to the openLocationModal function.
// For that HOC to function, it needs access to a redux provider,
// so we wrap it in the wrappedInReduxProvider HOC.
export default wrappedInReduxProvider(connectLocation(LocationModalOpener));
